import SlickSlider from 'slick-slider';

window.$ = window.jQuery;
if (typeof $.type === 'undefined') {
    $.type = function(obj) {
        return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    };
}

Drupal.behaviors.gallerySection = {
  attach: function (context) {
    $(document).ready(function () {
      
      let $gallery = $('section.gallery');

      if ($gallery.length > 0) {
        $('.gallery__slide', $gallery).slick(
          {
            dots: true,
            arrows: false,
            prevArrow: '<button class="chevron-prev">' + Drupal.t('Previous') + '</button>',
            nextArrow: '<button class="chevron-next">' + Drupal.t('Next') + '</button>',
            infinite: true,

            centerMode: true,
            centerPadding: '200px',
            slidesToShow: 1,
            swipeToSlide: true,

            responsive: [
              {
                breakpoint: 1200,
                settings: {
                  arrows: false,
                  centerMode: false,
                  slidesToShow: 1
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  arrows: false,
                  centerMode: false,
                  slidesToShow: 1
                }
              },
            ]
          }
        );


        /**
         * Click handler.
         *
         * @type {*|jQuery.fn.init|jQuery|HTMLElement}
         */
        let $slides = $('img', $gallery);
        $slides.on('mousedown', function (e) {
          $slides.on('mouseup mousemove', function handler(evt) {
            if (evt.type === 'mouseup') {
              let $slideImage = $(evt.target.closest('img'));
              let $modal = $($('template#gallery_modal').clone().html());

              $('img', $modal).attr('src', $slideImage.attr('src'));
              $('img', $modal).attr('alt', $slideImage.attr('alt'));

              $('html').addClass('modal-open');

              $modal.click(function (e) {
                $('html').removeClass('modal-open');
                $(e.currentTarget).remove();
              });

              $('main').append($modal).show();
            } else {
              // drag
            }
            $slides.off('mouseup mousemove', handler);
          });

        });
      }
    });
  }
};
